/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

/**
 * User Profiles
 */
export const UPDATE_LISTING_CURRENT_PAGE = "UPDATE_LISTING_CURRENT_PAGE";
export const UPDATE_LISTING_PAGE_SIZE = "UPDATE_LISTING_PAGE_SIZE";

export const USERPROFILES_FILTER_VALUE_ADD = "USERPROFILES_FILTER_VALUE_ADD";
export const USERPROFILES_FILTER_VALUE_REMOVE = "USERPROFILES_FILTER_VALUE_REMOVE";
export const USERPROFILES_FILTER_PROVINCE_VALUE_REMOVE =
  "USERPROFILES_FILTER_PROVINCE_VALUE_REMOVE";
export const USERPROFILES_FILTER_VALUE_UPDATE = "USERPROFILES_FILTER_VALUE_UPDATE";
export const USERPROFILES_FILTER_VALUE_RESET = "USERPROFILES_FILTER_VALUE_RESET";

/**
 * Individual user profile
 */
export const USERPROFILES_SEARCH_SUCCESS = "USERPROFILES_SEARCH_SUCCESS";
export const USERPROFILES_SEARCH = "USERPROFILES_SEARCH";
export const USERPROFILES_SEARCH_FAIL = "USERPROFILES_SEARCH_FAIL";

export const USERPROFILE_LOAD_SUCCESS = "USERPROFILE_LOAD_SUCCESS";
export const USERPROFILE_LOAD = "USERPROFILE_LOAD";
export const USERPROFILE_LOAD_BY_EMAIL = "USERPROFILE_LOAD_BY_EMAIL";
export const USERPROFILE_LOAD_FAIL = "USERPROFILE_LOAD_FAIL";

/**
 * Program profile
 */
export const USERPROFILE_FETCH_PROGRAM_PROFILE = "USERPROFILE_FETCH_PROGRAM_PROFILE";
export const USERPROFILE_FETCH_PROGRAM_PROFILE_FAIL = "USERPROFILE_FETCH_PROGRAM_PROFILE_FAIL";
export const USERPROFILE_FETCH_PROGRAM_PROFILE_SUCCESS =
  "USERPROFILE_FETCH_PROGRAM_PROFILE_SUCCESS";
export const USERPROFILE_UPDATE_PROGRAM_PROFILE = "USERPROFILE_UPDATE_PROGRAM_PROFILE";
export const USERPROFILE_UPDATE_PROGRAM_PROFILE_SUCCESS =
  "USERPROFILE_UPDATE_PROGRAM_PROFILE_SUCCESS";
export const USERPROFILE_UPDATE_PROGRAM_PROFILE_FAILURE =
  "USERPROFILE_UPDATE_PROGRAM_PROFILE_FAILURE";

/**
 * Update
 */
export const UPDATE_USERPROFILE_ID = "UPDATE_USERPROFILE_ID";

export const USERPROFILE_UPDATE_SUCCESS = "USERPROFILE_UPDATE_SUCCESS";
export const USERPROFILE_UPDATE = "USERPROFILE_UPDATE";
export const USERPROFILE_UPDATE_FAIL = "USERPROFILE_UPDATE_FAIL";

export const USERPROFILE_UPDATE_BLOCK_SHIPPING = "USERPROFILE_UPDATE_BLOCK_SHIPPING";
export const USERPROFILE_UPDATE_BLOCK_SHIPPING_FAIL = "USERPROFILE_UPDATE_BLOCK_SHIPPING_FAIL";
export const USERPROFILE_UPDATE_BLOCK_SHIPPING_SUCCESS =
  "USERPROFILE_UPDATE_BLOCK_SHIPPING_SUCCESS";

export const USERPROFILE_UPDATE_IS_PRIVATE = "USERPROFILE_UPDATE_IS_PRIVATE";
export const USERPROFILE_UPDATE_IS_PRIVATE_FAIL = "USERPROFILE_UPDATE_IS_PRIVATE_FAIL";
export const USERPROFILE_UPDATE_IS_PRIVATE_SUCCESS = "USERPROFILE_UPDATE_IS_PRIVATE_SUCCESS";

/**
 * Comments
 */
export const USERPROFILE_LOAD_COMMENTS_SUCCESS = "USERPROFILE_LOAD_COMMENTS_SUCCESS";
export const USERPROFILE_LOAD_COMMENTS = "USERPROFILE_LOAD_COMMENTS";
export const USERPROFILE_LOAD_COMMENTS_FAIL = "USERPROFILE_LOAD_COMMENTS_FAIL";

export const USERPROFILE_UPDATE_COMMENT_SUCCESS = "USERPROFILE_UPDATE_COMMENT_SUCCESS";
export const USERPROFILE_UPDATE_COMMENT = "USERPROFILE_UPDATE_COMMENT";
export const USERPROFILE_UPDATE_COMMENT_FAIL = "USERPROFILE_UPDATE_COMMENT_FAIL";

export const USERPROFILE_ADD_COMMENT = "USERPROFILE_ADD_COMMENT";
export const USERPROFILE_ADD_COMMENT_FAIL = "USERPROFILE_ADD_COMMENT_FAIL";
export const USERPROFILE_ADD_COMMENT_SUCCESS = "USERPROFILE_ADD_COMMENT_SUCCESS";

/**
 * Distribution Lists
 */
export const USERPROFILE_DL_LOAD = "USERPROFILE_DL_LOAD";
export const USERPROFILE_DL_LOAD_FAIL = "USERPROFILE_DL_LOAD_FAIL";
export const USERPROFILE_DL_LOAD_SUCCESS = "USERPROFILE_DL_LOAD_SUCCESS";

export const USERPROFILE_DL_REMOVE = "USERPROFILE_DL_REMOVE";
export const USERPROFILE_DL_REMOVE_FAIL = "USERPROFILE_DL_REMOVE_FAIL";
export const USERPROFILE_DL_REMOVE_SUCCESS = "USERPROFILE_DL_REMOVE_SUCCESS";

export const USERPROFILE_DL_REMOVE_ALL = "USERPROFILE_DL_REMOVE_ALL";
export const USERPROFILE_DL_REMOVE_ALL_SUCCESS = "USERPROFILE_DL_REMOVE_ALL_SUCCESS";
export const USERPROFILE_DL_REMOVE_ALL_FAIL = "USERPROFILE_DL_REMOVE_ALL_FAIL";

/**
 * Benefits
 */
export const USERPROFILE_CLAIM_BENEFIT = "USERPROFILE_CLAIM_BENEFIT";
export const USERPROFILE_CLAIM_BENEFIT_FAIL = "USERPROFILE_CLAIM_BENEFIT_FAIL";
export const USERPROFILE_CLAIM_BENEFIT_SUCCESS = "USERPROFILE_CLAIM_BENEFIT_SUCCESS";
export const USERPROFILE_CLAIM_BENEFIT_RESET = "USERPROFILE_CLAIM_BENEFIT_RESET";
export const USERPROFILE_VSBENEFITS_RESET = "USERPROFILE_VSBENEFITS_RESET";
export const USERPROFILE_LOAD_VSBENEFITS = "USERPROFILE_LOAD_VSBENEFITS";
export const USERPROFILE_LOAD_VSBENEFITS_FAIL = "USERPROFILE_LOAD_VSBENEFITS_FAIL";
export const USERPROFILE_LOAD_VSBENEFITS_SUCCESS = "USERPROFILE_LOAD_VSBENEFITS_SUCCESS";
export const USERPROFILE_PROVISION_VSBENEFITS = "USERPROFILE_PROVISION_VSBENEFITS";
export const USERPROFILE_PROVISION_VSBENEFITS_FAIL = "USERPROFILE_PROVISION_VSBENEFITS_FAIL";
export const USERPROFILE_PROVISION_VSBENEFITS_SUCCESS = "USERPROFILE_PROVISION_VSBENEFITS_SUCCESS";
export const USERPROFILE_EXTEND_VSBENEFITS = "USERPROFILE_EXTEND_VSBENEFITS";
export const USERPROFILE_EXTEND_VSBENEFITS_FAIL = "USERPROFILE_EXTEND_VSBENEFITS_FAIL";
export const USERPROFILE_EXTEND_VSBENEFITS_SUCCESS = "USERPROFILE_EXTEND_VSBENEFITS_SUCCESS";
export const USERPROFILE_END_VSBENEFITS = "USERPROFILE_END_VSBENEFITS";
export const USERPROFILE_END_VSBENEFITS_FAIL = "USERPROFILE_END_VSBENEFITS_FAIL";
export const USERPROFILE_END_VSBENEFITS_SUCCESS = "USERPROFILE_END_VSBENEFITS_SUCCESS";

export const USERPROFILE_GET_PROFILE_BENEFITS = "USERPROFILE_GET_PROFILE_BENEFITS";
export const USERPROFILE_GET_PROFILE_BENEFITS_FAIL = "USERPROFILE_GET_PROFILE_BENEFITS_FAIL";
export const USERPROFILE_GET_PROFILE_BENEFITS_SUCCESS = "USERPROFILE_GET_PROFILE_BENEFITS_SUCCESS";
